import React from 'react'
import PropTypes from 'prop-types'
import { Tooltip } from '@progress/kendo-react-tooltip'
import '/src/static/css/tooltip.css'

export default function CustomTooltip({ children, maxLength, position, className }) {
  if (typeof children === 'string') {
    if (children.length <= maxLength) return <span className={className}>{children}</span>

    return (
      <Tooltip position={position} anchorElement="target">
        <span className={className} title={children}>{`${children.substr(0, maxLength)} ...`}</span>
      </Tooltip>
    )
  }

  return (
    <Tooltip position={position} anchorElement="target">
      {children}
    </Tooltip>
  )
}

CustomTooltip.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.object.isRequired,
  ]).isRequired,
  maxLength: PropTypes.number,
  position: PropTypes.string,
  className: PropTypes.string
}

CustomTooltip.defaultProps = {
  maxLength: 35,
  position: 'top',
  className:  ''
}
